import { Icon, Popup, Table, TableFooter, TableHeaderCell, TableRow } from "semantic-ui-react";

import "./CommonTable.scss";

export const CommonTable = ({
  tableHeaderData = [],
  children,
  singleLine = true,
  isSimulateView,
  tableFooterCol = "5",
  tableFooterChild,
  enableTableFooter = false,
  testId = "common-table"
}: any) => {
  const tableStyle = (data: any) => {
    return {
      tableHeader: data?.textAlign === "right" ? "pr-1" : ""
    };
  };
  return singleLine ? (
    <div data-testid={testId} className="tableContainer">
      <Table singleLine={singleLine} className="table" celled>
        <Table.Header data-testid={`${testId}-header`}>
          <Table.Row>
            {tableHeaderData.map((data: any, index: any) => {
              return (
                <Table.HeaderCell
                  className={
                    isSimulateView
                      ? `tableHeaderSimulate ${tableStyle(data).tableHeader}`
                      : `tableHeader pr-1 ${tableStyle(data).tableHeader}`
                  }
                  width={data?.col}
                  key={index}
                  textAlign={data?.textAlign || "left"}
                >
                  {data?.name || ""}
                </Table.HeaderCell>
              );
            })}
          </Table.Row>
        </Table.Header>
        <Table.Body data-testid={`${testId}-body`}>{children}</Table.Body>
        {enableTableFooter ? (
          <TableFooter className="tableFooterMain">
            <TableRow>
              <TableHeaderCell colSpan={tableFooterCol}>{tableFooterChild}</TableHeaderCell>
            </TableRow>
          </TableFooter>
        ) : null}
      </Table>
    </div>
  ) : (
    <div className="tableContainer">
      <Table celled className="table" structured>
        <Table.Header>
          <Table.Row>
            {tableHeaderData.map((data: any, index: any) => {
              return (
                <Table.HeaderCell
                  className={isSimulateView ? "tbleHeaderSimulate" : "tableHeader"}
                  width={data?.col}
                  key={index}
                >
                  {data?.name || ""}
                  {data?.information ? (
                    <Popup
                      content={data?.information}
                      trigger={<Icon className="iconPM" name="exclamation circle" />}
                    />
                  ) : null}
                </Table.HeaderCell>
              );
            })}
          </Table.Row>
        </Table.Header>
        <Table.Body>{children}</Table.Body>
      </Table>
    </div>
  );
};
